<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <!-- 検索エリア -->
          <client-search-area />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import ClientSearchArea from "../components/ClientSearchArea.vue";

export default {
  name: "ClientSearch",

  components: {
    ClientSearchArea,
  },
  data: () => ({
  }),
  computed: {},
  methods: {
  },
};
</script>